export default function Pagination({ page, totalPages, onChange }) {
  return (
    <div className="flex items-center justify-center gap-2 py-6">
      <button onClick={() => onChange(page - 1)} disabled={page === 1}
        className="px-4 py-2 rounded-md border hover:bg-gray-50">Previous</button>

      {[...Array(totalPages)].map((_, i) => (
        <button key={i}
          onClick={() => onChange(i + 1)}
          className={`px-4 py-2 rounded-md border 
            ${page === i+1 ? "bg-[#FF4A1F] text-white" : "hover:bg-gray-50"}`}>
          {i + 1}
        </button>
      ))}

      <button onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className="px-4 py-2 rounded-md border hover:bg-gray-50">Next</button>
    </div>
  );
}
